module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline timeline-mobile",
    style: ({
      display: _vm.selectedDecade === 0 && !_vm.timelineTransitioning ? 'none' : 'block'
    }),
    attrs: {
      "tabindex": "0"
    }
  }, [_c('h2', {
    ref: "decadeHeader",
    staticClass: "decade-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDecade + 's'))])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.ID
    }, [_c('img', {
      attrs: {
        "src": item.main_image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-copy"
    }, [_c('h3', [_vm._v(_vm._s(item.year))]), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s(item.the_title)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.the_content)
      }
    })])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9c1b29f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c1b29f6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./timeline/js/components/TimelineMobile.vue
// module id = 59
// module chunks = 0